import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=48043ac2&scoped=true"
import script from "./NavList.vue?vue&type=script&lang=js"
export * from "./NavList.vue?vue&type=script&lang=js"
import style0 from "./NavList.vue?vue&type=style&index=0&id=48043ac2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48043ac2",
  null
  
)

export default component.exports